import { render, staticRenderFns } from "./paymentOrder.vue?vue&type=template&id=316a5542"
import script from "./paymentOrder.vue?vue&type=script&lang=js"
export * from "./paymentOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports